import styled from "styled-components";

import MenuItems from "./MenuItems";
import { useContext } from "react";
import { NavigationContext } from "../../contexts/NavigationContext";

const DesktopNav = styled.nav`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin: 0 auto;
  font-size: 1em;
  color: var(--color-grey-600);
`;
const Menus = styled.ul`
  display: flex;
  list-style: none;
`;

function Navbar() {
  const { menuItems, secondaryMenu, pageTitle } = useContext(NavigationContext);
  const depthLevel = 0;

  // Create a new menu array, substituting the first item's title with pageTitle
  const modifiedMenuItems = menuItems.map((menu, index) => {
    if (index === 0) {
      return { ...menu, title: pageTitle };
    }
    return menu;
  });

  // This function will be used to integrate the secondary menu
  function integrateSecondaryMenu(primaryMenu, secondaryMenu) {
    // Clone the primary menu to avoid mutations
    const integratedMenu = [...primaryMenu];

    // Append the secondary menu at the end, bu pushing it at the end of the existing array
    integratedMenu.push(secondaryMenu);

    return integratedMenu;
  }

  // Integrate the secondary menu
  const integratedMenuItems = integrateSecondaryMenu(
    modifiedMenuItems,
    secondaryMenu
  );

  return (
    <DesktopNav>
      <Menus>
        {integratedMenuItems.map((menu, index) => (
          <MenuItems items={menu} key={index} depthLevel={depthLevel} />
        ))}
      </Menus>
    </DesktopNav>
  );
}

export default Navbar;
